import axios from "axios";
import React from "react";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import "./SendCampaign.css";

import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";

const SendAudioCampaign = () => {
  const initialState = {
    // mobile_no: "",
    // audio: "",
    // count: "",
    groupimport: "",
    txtimport: "",
    csvimport: "",
  };
  const [numbercounter, setNumberCounter] = useState("");
  const [mobile_no, setMobile_No] = useState("");
  const [count, setCount] = useState(0);
  const [audios, setAudios] = useState([]);
  const [audioId, setAudioId] = useState("");
  const [selectedAudio, setSelectedAudio] = useState(null);
  const [responseNumber, setResponseNumber] = useState("");
  const [contactGroupData, setContactGroupData] = useState([]);
  const [values, setValues] = useState(initialState);
  const [isloading, setLoading] = useState(false);
  const [userProfile, setUserProfile] = useState(null);

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const theme = localStorage.getItem("theme");
    document.body.className = theme;
    if (numbercounter.length == 0) {
      setNumberCounter(0);
    }
  }, [count]);

  const RowCount = (text) => {
    // Filter to allow only digits and newlines (remove all letters and special chars except newlines)
    const filteredText = text.replace(/[^0-9\n\r]/g, '');
    console.log(filteredText);
    var lines = filteredText.split(/\r|\r\n|\n/);
    console.log(lines);
    setCount(lines.length);
    // console.log("count", count);
    setNumberCounter(count);
    setMobile_No(filteredText);
  };

  const GroupRowCount = (text) => {
    // Filter to allow only digits and newlines (remove all letters and special chars except newlines)
    const filteredText = text.replace(/[^0-9\n\r]/g, '');
    console.log(filteredText);
    // return;
    var lines = filteredText.split(/\r|\r\n|\n/);
    console.log(lines);
    setCount(lines.length);
    // console.log("count", count);
    setNumberCounter(count);
    setMobile_No(filteredText);
  };

  const OnSubmit = () => {
    setLoading(true);
    if (!audioId) {
      toast.error("audio is mandatory");
      setLoading(false);
      return;
    }

    const token = localStorage.getItem("token");
    axios
      .post(
        `${BASE_URL}admin/addSendMessage`,
        {
          contact_no: mobile_no,
          msg_count: count,
          audio_id: audioId,
          response_number: responseNumber,
          media_type:"VOICE"
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "Application/json",
            version: "1.0.0",
          },
        }
      )
      .then((response) => {
        if (response.data.success == false) {
          toast.error(response.data.message);
          setLoading(false);
        } else {
          toast.success(response.data.message);
          setLoading(false);
          setNumberCounter("");
          setMobile_No("");
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  const sanitizeNumbers = (rawValues) => {
    const seen = new Set();
    const result = [];
    for (const val of rawValues) {
      const num = String(val).trim().replace(/[^0-9]/g, "");
      if (num && !seen.has(num)) {
        seen.add(num);
        result.push(num);
      }
    }
    return result;
  };

  const handleFileImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const fileName = file.name.toLowerCase();

    if (fileName.endsWith(".csv")) {
      Papa.parse(file, {
        skipEmptyLines: true,
        complete: (results) => {
          const rawValues = results.data.map((row) => row[0]).filter((v) => v !== undefined && v !== null);
          const numbers = sanitizeNumbers(rawValues);
          const text = numbers.join("\n");
          setMobile_No(text);
          setCount(numbers.length);
        },
      });
    } else if (fileName.endsWith(".xlsx") || fileName.endsWith(".xls")) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        const data = new Uint8Array(ev.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        const rawValues = rows.map((row) => row[0]).filter((v) => v !== undefined && v !== null);
        const numbers = sanitizeNumbers(rawValues);
        const text = numbers.join("\n");
        setMobile_No(text);
        setCount(numbers.length);
      };
      reader.readAsArrayBuffer(file);
    } else if (fileName.endsWith(".txt")) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        const text = ev.target.result.trim();
        const lines = text.split(/\r|\r\n|\n/).filter((l) => l !== "");
        const numbers = sanitizeNumbers(lines);
        setMobile_No(numbers.join("\n"));
        setCount(numbers.length);
      };
      reader.readAsText(file);
    } else {
      toast.error("Please upload a .txt, .csv, .xlsx, or .xls file");
    }
    e.target.value = "";
  };

  const getApprovedAudios = () => {
    const token = localStorage.getItem("token");
    axios
      .get(`${BASE_URL}admin/getUserApprovedAudios`, {
        headers: {
          "x-access-token": `${token}`,
          version: "1.0.0",
          "Content-Type": "Application/json",
        },
      })
      .then((response) => {
        setAudios(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }; //end of GetAllAudios

  const GetAllContactGroup = () => {
    const token = localStorage.getItem("token");
    axios
      .post(
        `${BASE_URL}admin/getAllContactGroup`,
        { page: 1 },
        {
          headers: {
            "x-access-token": `${token}`,
            version: "1.0.0",
            "Content-Type": "Application/json",
          },
        }
      )
      .then((response) => {
        if (response.data.data == false) {
          // toast.error(response.data.message);
        } else {
          // toast.success(response.data.message);
          setContactGroupData(response.data.data);
          console.log("transactionlog response:", response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchUserProfile = () => {
    const token = localStorage.getItem("token");
    axios
      .get(`${BASE_URL}auth/view-profile`, {
        headers: { "x-access-token": token, version: "1.0.0", "Content-Type": "Application/json" },
      })
      .then((response) => {
        if (response.data.success) setUserProfile(response.data.data);
      })
      .catch(() => {});
  };

  useEffect(() => {
    getApprovedAudios();
    GetAllContactGroup();
    fetchUserProfile();
    const theme = localStorage.getItem("theme");
    document.body.className = theme;
  }, []);

  return (
    <div className="send-campaign-container">
      <div className="send-campaign-card card">
        <div className="send-campaign-header card-header">
          <h6>Send Voice SMS</h6>
        </div>

        {/* Campaign Summary notification banner */}
        {count > 0 && selectedAudio && (() => {
          const creditsPerNumber = selectedAudio.credits_per_number || 1;
          const totalCredits = creditsPerNumber * count;
          const rate = userProfile ? parseFloat(userProfile.voice_rate) || 0 : 0;
          const rupeeCost = rate > 0 ? (totalCredits * rate).toFixed(2) : null;
          const availableCredits = userProfile ? parseInt(userProfile.balance) || 0 : 0;
          const insufficient = availableCredits < totalCredits;
          return (
            <div style={{
              background: insufficient ? "#fff3e0" : "#e8f5e9",
              borderBottom: `1px solid ${insufficient ? "#ffcc80" : "#a5d6a7"}`,
              padding: "10px 20px",
              display: "flex",
              alignItems: "center",
              gap: 12,
              flexWrap: "wrap",
              fontSize: 13,
            }}>
              <i className={`fa ${insufficient ? "fa-exclamation-triangle" : "fa-info-circle"}`}
                style={{ color: insufficient ? "#e65100" : "#2e7d32", fontSize: 15 }} />
              <span><strong style={{ color: insufficient ? "#e65100" : "#2e7d32" }}>Campaign Summary</strong></span>
              <span style={{ color: "#555" }}>Credits required: <strong>{totalCredits}</strong> ({creditsPerNumber} cr × {count} contacts)</span>
              {rupeeCost && <span style={{ color: "#555" }}>Est. cost: <strong>₹{rupeeCost}</strong></span>}
              <span style={{ color: insufficient ? "#c62828" : "#1b5e20" }}>
                Balance: <strong>{availableCredits} credits</strong>
                {userProfile?.rupee_balance != null && <span> | ₹{parseFloat(userProfile.rupee_balance).toFixed(2)}</span>}
              </span>
              {insufficient && <span style={{ color: "#c62828" }}>— Insufficient. Convert ₹ balance from Dashboard.</span>}
            </div>
          );
        })()}

        <div className="send-campaign-body card-body">
          {/* Enter Mobile Number */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">
              Enter Mobile Number:-
            </label>
            <textarea
              rows={4}
              className="form-control-responsive"
              placeholder="Enter 10 digits mobile number here)"
              onChange={(e) => RowCount(e.target.value)}
              name="mobile_no"
              value={mobile_no}
            ></textarea>
          </div>

          {/* Select Audio */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Select Audio :-</label>
            <select
              className="form-control-responsive"
              onChange={(e) => {
                const id = e.target.value;
                setAudioId(id);
                setSelectedAudio(audios.find((a) => String(a.audio_id) === String(id)) || null);
              }}
              defaultValue=""
            >
              <option value="" disabled>
                Select audio
              </option>
              {audios.map((audio) => (
                <option key={audio.audio_id} value={audio.audio_id}>
                  {audio.audio_file_display_name}
                </option>
              ))}
            </select>
          </div>

          {/* Select Response Key */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">
              Select Response Key :-
            </label>
            <select
              className="form-control-responsive"
              onChange={(e) => setResponseNumber(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>
                Select Response Key
              </option>
              {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
                <option key={number} value={number}>
                  {number}
                </option>
              ))}
            </select>
          </div>

          {/* Count */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Count:-</label>
            <input
              type="text"
              className="form-control-responsive"
              name="numbercounter"
              value={count}
              disabled
            />
          </div>

          {/* Group Import */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Group Import</label>
            <select
              className="form-control-responsive"
              onChange={(e) => GroupRowCount(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>
                --select--
              </option>
              {contactGroupData &&
                contactGroupData.map((item, index) => (
                  <option key={index} value={item.contact_no}>
                    {item.group_name}
                  </option>
                ))}
            </select>
          </div>

          {/* CSV / Excel / TXT Import */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Import(CSV/Excel/txt)</label>
            <input
              type="file"
              className="form-control-responsive"
              accept=".csv,.xlsx,.xls,.txt"
              onChange={handleFileImport}
            />
          </div>

          {/* Submit Button */}
          <div className="submit-btn-container">
            {isloading ? (
              <button type="button" className="btn btn-primary" disabled>
                <i className="fa fa-spinner fa-spin  "></i>
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => OnSubmit()}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default SendAudioCampaign;
